import { render, staticRenderFns } from "./PaginationMatching.vue?vue&type=template&id=9d4e3de0&scoped=true"
import script from "./PaginationMatching.vue?vue&type=script&lang=js"
export * from "./PaginationMatching.vue?vue&type=script&lang=js"
import style0 from "./PaginationMatching.vue?vue&type=style&index=0&id=9d4e3de0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e3de0",
  null
  
)

export default component.exports